// extracted by mini-css-extract-plugin
export default {"wrapperMain":"SuccessMod_wrapperMain__aKNXw","Btn":"SuccessMod_Btn__2BgBD","img":"SuccessMod_img__bkqj9"};